import { render, staticRenderFns } from "./IncomeCompareTable.vue?vue&type=template&id=4b5ce020&"
import script from "./IncomeCompareTable.vue?vue&type=script&lang=js&"
export * from "./IncomeCompareTable.vue?vue&type=script&lang=js&"
import style0 from "./IncomeCompareTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports